import { ErrorState, IErrorPageButtons, IErrorState } from './error.state';
import Image from 'next/legacy/image';
import Link from 'next/link';
import style from './error-page.module.scss';
import { useState } from 'react';
import StartProjectModal from '../interactions/start-project/start-project.modal';
import { ReactSVG } from 'react-svg';
import { useTranslations } from 'next-intl';

interface IErrorProps {
  errorStatus: string;
  prefix: string;
}

const ErrorPageComponent = ({ errorStatus, prefix }: IErrorProps) => {
  const t = useTranslations();
  const { image, text, items, linkText, sufix }: IErrorState = ErrorState;
  const [isStartProjectModalOpened, setStartProjectModalOpened] = useState(false);

  const openStartProjectWindow = () => {
    setStartProjectModalOpened(true);
  };

  const goBack = () => {
    history.back();
  };

  return (
    <>
      <section className="w-full py-20">
        <div className="mx-auto max-w-[620px] px-5 md:px-0">
          <div className="text-3xl font-semibold text-center mb-3">{t(errorStatus)}</div>
          <div className="text-base font-normal text-gray-600 mb-8 text-center">
            {t(prefix)}
            <span onClick={() => goBack()} className="ml-1 text-blue-600 cursor-pointer hover:underline transition-all duration-500">
              {t(linkText)}
            </span>
            {t(sufix)}
          </div>
          <div className="w-full h-[114px] md:h-[200px] relative mb-8">
            <Image 
              sizes="400px 200px" 
              src={image} 
              alt={errorStatus} 
              layout={'fill'} 
              className="object-contain"
            />
          </div>
          <div className="text-base font-normal text-center mb-8 text-gray-600">{t(text)}</div>
          <div className="flex flex-wrap gap-8 justify-center">
            {items.map((item: IErrorPageButtons, index: number) => {
              switch (item.type) {
                case 'link':
                  return (
                    <Link key={index} href={item.link} legacyBehavior>
                      <a className="group flex grow justify-between items-center gap-3 px-4 py-5 border border-gray-200 rounded-2xl hover:bg-primary-50 hover:border-primary-50 transition-colors">
                        <div className="flex grow items-center gap-3">
                          <Image
                            src={item.icon}
                            alt={item.title}
                            width={+item.width}
                            height={+item.height}
                          />
                          <div className="leading-none text-base font-semibold group-hover:text-primary-600">{item.title}</div>
                        </div>
                        <ReactSVG
                          src={'/icons/chev-right.svg'}
                          className="[&>div>svg>path]:group-hover:fill-primary-600 transition-colors"
                        />
                      </a>
                    </Link>
                  );
                case 'form':
                  return (
                    <div onClick={openStartProjectWindow} key={index} className='group cursor-pointer flex grow justify-between items-center gap-3 px-4 py-5 border border-gray-200 rounded-2xl hover:bg-primary-50 hover:border-primary-50 transition-colors'>
                      <div className="flex grow items-center gap-3">
                        <Image
                          src={item.icon}
                          alt={item.title}
                          width={+item.width}
                          height={+item.height}
                        />
                        <div className="leading-none text-base font-semibold group-hover:text-primary-600">{item.title}</div>
                      </div>
                      <ReactSVG
                        src={'/icons/chev-right.svg'}
                        className="[&>div>svg>path]:group-hover:fill-primary-600 transition-colors"
                      />
                    </div>
                  );
                default:
                  return null;
              }
            })}
          </div>
        </div>
      </section>
      {/* ====== Modals ====== */}
      <StartProjectModal
        isOpen={isStartProjectModalOpened}
        onClose={() => setStartProjectModalOpened(false)}
      />
    </>
  );
};

export default ErrorPageComponent;
